import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuthStore } from '../../store/authStore'
import { useAddComment } from '../../api/useComments'
import { getErrMsg } from '../../api/client'
import toast from 'react-hot-toast'

export default function CommentForm({ mangaId, parentId = null, onCancel = null }) {
  const isAuth = useAuthStore((s) => s.isAuth)
  const [text, setText] = useState('')
  const { mutate: addComment, isPending } = useAddComment(mangaId)

  if (!isAuth && !parentId) {
    return (
      <div className="p-4 rounded-xl text-sm text-center bg-surface text-muted">
        <Link to="/login" className="font-semibold text-accent">Войдите</Link>{' '}
        чтобы оставить комментарий
      </div>
    )
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!text.trim()) return
    addComment({ text: text.trim(), parent_id: parentId }, {
      onSuccess: () => {
        setText('')
        toast.success(parentId ? 'Ответ добавлен' : 'Комментарий добавлен')
        onCancel?.()
      },
      onError: (err) => toast.error(getErrMsg(err, 'Не удалось добавить комментарий')),
    })
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-2">
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder={parentId ? 'Напишите ответ...' : 'Напишите комментарий...'}
        rows={parentId ? 2 : 3}
        autoFocus={!!parentId}
        className="w-full px-4 py-3 rounded-xl text-sm resize-none outline-none transition-colors bg-surface text-fg border border-line focus:border-accent"
      />
      <div className="flex items-center justify-end gap-3">
        {onCancel && (
          <button type="button" onClick={onCancel} className="text-sm text-muted hover:text-fg transition-colors">
            Отмена
          </button>
        )}
        <button
          type="submit"
          disabled={!text.trim() || isPending}
          className="px-5 py-2 rounded-lg text-sm font-bold transition-all disabled:opacity-50 bg-accent text-on-accent hover:opacity-90"
        >
          {isPending ? 'Отправка...' : parentId ? 'Ответить' : 'Отправить'}
        </button>
      </div>
    </form>
  )
}
